import React, {Component} from 'react';
import {webviewCall} from "../utils/webview";
import {hitEvent, hits} from "../utils/log";
import ContinueWithAppModal from "./ContinueWithAppModal";
import AppContext from "../contexts/AppContext";
import clientStorage from "../utils/client-storage";

export default class FileChooseButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      image: null,
    };

    this.fileFieldRef = React.createRef();

    this.handleBrowserFileSelected = this.handleBrowserFileSelected.bind(this);
    this.handleWebviewFileSelected = this.handleWebviewFileSelected.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleError = this.handleError.bind(this);
    this.triggerSelectFile = this.triggerSelectFile.bind(this);
    this.logFileSelected = this.logFileSelected.bind(this);
  }

  componentDidMount() {
    if (this.props.listener) {
      this.props.listener.setListener(this.handleWebviewFileSelected);
    } else {
      window.webviewEventsListeners.photoSelected.setListener(this.handleWebviewFileSelected);
    }
  }

  componentWillUnmount() {
    if (this.props.listener) {
      this.props.listener.removeListener();
    } else {
      window.webviewEventsListeners.photoSelected.removeListener();
    }
  }

  triggerSelectFile() {
    if (window.clientConfig.isWebview) {
      const params = {
        func: this.props.func || "onNativeAppPhotoSelected",
        use_crop: 0,
        num_photos: 1,
        show: "gallery",
        tab: "faces",
        neurocamera: 1,
      };

      webviewCall("nativePhotoSelect", params);
    } else {
      if (this.fileFieldRef.current) {
        this.fileFieldRef.current.value = "";
        this.fileFieldRef.current.click();
      }
    }
  }

  handleError(code, message) {
    this.props.onError && this.props.onError(code, message);
  }

  logFileSelected() {
    hitEvent(hits.PHOTO_SELECT);
  }

  handleBrowserFileSelected(file) {
    this.logFileSelected();
    this.props.onFileSelected && this.props.onFileSelected(file);
  }

  handleWebviewFileSelected(data) {
    if (!data || !data.photos || data.photos.length === 0) {
      return;
    }

    const photo = data.photos.pop();

    this.logFileSelected();

    const imageUrl = photo.image_url.replace("http://", "https://");
    this.props.onFileSelected && this.props.onFileSelected(imageUrl);
  }

  handleClick(e) {
    if ((window.clientConfig.isWebMobile || window.clientConfig.isWebMobileDesktopMode) && !window.appConfig.isTestInstance) {
      const limit = window.clientConfig.isWebMobile
        ? window.appConfig.processings.mobilePhotosLimit
        : window.appConfig.processings.mobileDesktopModePhotosLimit;

      if (clientStorage.getProcessedPhotosAmount() >= limit && 0 < limit) {
        this.context.pushModal(<ContinueWithAppModal
          key="FileChooseButton_ContinueWithAppModal"
        />);
        return;
      }
    }

    this.props.onClick && this.props.onClick(e);
    this.triggerSelectFile();
  }

  render() {
    if (this.props.hidden) {
      return <React.Fragment />;
    }

    return <React.Fragment>
      <button
        disabled={this.props.disabled}
        className={this.props.className}
        onClick={this.handleClick.bind(this)}>
        <span
          hidden={this.props.progress === 0}
          className="effects"
          style={{width: (this.props.progress*100) + "%"}}>
            <span children={this.props.progressContent || ""} />
        </span>
        {this.props.children}
        <svg viewBox="0 0 17 15" fill="none">
          <path d="M16.336 0H6.64a.672.672 0 0 0-.519.242l-1.128 1.37H3.785V.969C3.75.11 2.492.112 2.457.968v.645H.664A.655.655 0 0 0 0 2.258v12.097c0 .357.297.645.664.645h15.672c.367 0 .664-.29.664-.645V.645A.655.655 0 0 0 16.336 0zm-.664 13.71H1.328V2.903h3.984c.202 0 .393-.09.519-.242l1.13-1.37h8.71v12.42zM3.984 8.065c0 2.402 2.011 4.355 4.483 4.355 5.946-.239 5.945-8.472 0-8.71-2.472 0-4.483 1.953-4.483 4.355zM8.467 5c1.74 0 3.154 1.375 3.154 3.065-.173 4.066-6.136 4.064-6.309 0C5.313 6.375 6.729 5 8.467 5zm4.549-1.774c0-.357.297-.645.664-.645a.645.645 0 0 1 0 1.29.655.655 0 0 1-.664-.645z" fill="#302C40"/>
        </svg>
      </button>

      <input
        className="file-field-hidden"
        type="file"
        accept="image/*"
        ref={this.fileFieldRef}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => this.handleBrowserFileSelected(e.target.files[0])} />
    </React.Fragment>;
  }
}

FileChooseButton.contextType = AppContext;